function validateDateOfBirth(dateOfBirth, desiredAge) {
  var currentAgeNumber = new Date(Date.now()).getFullYear() - new Date(dateOfBirth).getFullYear();
  return currentAgeNumber < 0 ? false : desiredAge - currentAgeNumber >= 0;
}

export { validateDateOfBirth };
//# sourceMappingURL=validateDateOfBirth.js.map